<template>
    <span>Kushim</span>
</template>

<script>
export default {
    name: 'kus-base-topbar-title'
}
</script>
